import { FC } from 'react';

import styles from './EmptyData.module.scss';

interface IEmptyDataProps {
  title?: string;
  description?: string;
}

const EmptyData: FC<IEmptyDataProps> = ({
  title = 'Here is no data yet',
  description = 'No data available for this section. Please check back later or add new data to get started.',
}) => {
  return (
    <div className={styles.box}>
      <img src="/cloud.svg" alt="empty-data" />
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

export default EmptyData;
